require('../sass/main.scss');

require('../../node_modules/gsap/CSSPlugin.js');
require('../../node_modules/gsap/EasePack.js');
require('../../node_modules/gsap/TweenLite.js');
require('../../node_modules/gsap/TimelineLite.js');
require('./main.js');



//////////////////
// WEBPACK FOOTER
// ./_src/js/app.js
// module id = 0
// module chunks = 0